export default __webpack_public_path__ + "static/media/Template.9076aaf9.xlsx";